export default "__VITE_PUBLIC_ASSET__6cb6e92a__"